import axios from 'axios';
import config from '../config';
const DOMAIN = config.REACT_APP_SERVER_DOMAIN;

export const getEvent = async () => {
  // Pipeline local vehicle_events (api Falcon, menu monitoring id 13) —
  // l'ancien appel /api/monitoring/ pointait sur une route inexistante (404)
  return axios.get(`${DOMAIN}/event`);
};

export const getFalcon = async () => {
  // Proxy LIVE vers la plateforme Falcon via l'api locale (hash côté serveur)
  return axios.get(`${DOMAIN}/event/devices`);
};


export const getGeofences = async(params) => {
  const EVENT_API = config.REACT_APP_EVENT_API;
  return axios.get(`${EVENT_API}/api/point_in_geofences`, { params });
}


export const getConnectivity = async(params) => {
  // Rapport des connexions du jour — pipeline local (tracker_connectivity/score)
  return axios.get(`${DOMAIN}/event/connectivity`, { params });
}

export const getConnectivityDetail = async(params) => {
  // Détail par device — pipeline local
  return axios.get(`${DOMAIN}/event/connectivityDetail`, { params });
};

export const getConnectivityMonth = async (month) => {
  // Rapport mensuel — pipeline local
  return axios.get(`${DOMAIN}/event/connectivity/month`, { params: { month } });
};

export const getDashboard = async () => {
  // KPI de santé de la flotte (onglet Vue d'ensemble) — pipeline local
  return axios.get(`${DOMAIN}/event/dashboard`);
};

export const getFileControle = async () => {
  // File de contrôle du jour — devices déconnectés priorisés (SLA puis
  // ancienneté du silence), signalements du jour et rapports ouverts
  return axios.get(`${DOMAIN}/event/fileControle`);
};

export const getCoherenceLiaisons = async () => {
  // Cohérence des liaisons capteur ↔ véhicule (Task 92) — orphelins,
  // traceurs actifs non liés, liens muets (> 30 j)
  return axios.get(`${DOMAIN}/event/coherence`);
};

export const getDevicesEtat = async () => {
  // Dernier état de connectivité connu par device (Task 92) — garde-fous
  // de l'Affectation Falcon (ne pas relier un capteur muet en confiance)
  return axios.get(`${DOMAIN}/event/devicesEtat`);
};

export const getFicheDevice = async (deviceId) => {
  // Fiche traceur 360° — identité, état courant, courbe 30 j, événements,
  // opérations, rapports hors ligne, badge d'écart de chaînage et historique
  // des liaisons du device (tiroir de diagnostic)
  return axios.get(`${DOMAIN}/event/fiche/${deviceId}`);
};

export const getLiaisonHistorique = async (params) => {
  // Journal des mouvements de liaison capteur <-> véhicule (Task 93) —
  // filtres optionnels device_id / id_vehicule, limit clampé côté api
  return axios.get(`${DOMAIN}/event/liaisonHistorique`, { params });
};

export const getClientRapportMensuel = async (idClient, mois) => {
  // Données du rapport mensuel de connectivité d'un client (PDF) —
  // objectif SLA, résumé du mois, détail par device. mois = 'YYYY-MM'
  // (optionnel : mois métier courant par défaut)
  return axios.get(`${DOMAIN}/event/client/${idClient}/rapportMensuel`, {
    params: mois ? { mois } : {},
  });
};